window.addEventListener("load", function () {
  if ($("#swiperEvent").length > 0) {
    new Swiper("#swiperEvent", {
      navigation: {
        nextEl: ".swiper-button-next--swiperEvent",
        prevEl: ".swiper-button-prev--swiperEvent",
      },
      loop: true,
      // autoplay: {
      //   delay: 10000,
      // },



      
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      effect: 'coverflow',
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false,
      },
      spaceBetween: 0,
      lazy: {
        loadPrevNext: true,
      },
      breakpoints: {
        769: {
          slidesPerView: "auto",
          coverflowEffect: {
            rotate: 0,
            stretch: 364,
            depth: 300,
            modifier: 1,
            slideShadows: true,
          },
        }
      },
    });
  }
});